import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './SupplierTaxIDField.module.scss';

export const SupplierTaxIDField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<FullInfoField
			label="supplierTaxIDLabel"
			value={restaurantForFullInfo?.supplier?.taxpayerId}
			containerClassName={style.container}
		/>
	);
};
